// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cxVQ","textarea":"styles_textarea__340WR"};